import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
export var isComposeAddinPinned = function (addinId) {
    var surfaceActionsOptions = getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions);
    return !!~surfaceActionsOptions.composeSurfaceAddins.indexOf(addinId);
};
export var isReadAddinPinned = function (addinId) {
    var surfaceActionsOptions = getOptionsForFeature(OwsOptionsFeatureType.SurfaceActions);
    return !!~surfaceActionsOptions.readSurfaceAddins.indexOf(addinId);
};
//# sourceMappingURL=IsAddinPinnedAdapter.js.map